import { useRef, useState } from "react";
import Header from "./Header";
import { checkValidData } from "../utils/validate";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { auth } from "../utils/firebase";
import { useDispatch } from "react-redux";
import { addUser } from "../utils/userSlice";
import { BG_URL, USER_AVTAR } from "../utils/constants";

const Login = () => {
  const [isSignInForm, setisSignInForm] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const dispatch = useDispatch();

  const name = useRef(null);
  const email = useRef(null); // in this hook i am referencing my email and password from my input boxes of email and pass
  const password = useRef(null);

  const handleButtonClick = () => {
    //Validate the form data
    // console.log(message);
    const message = checkValidData(email.current.value, password.current.value);
    setErrorMessage(message);
    if (message) return;

    //Sign In/ Sign Up logic

    if (!isSignInForm) {
      //Sign Up logic
      createUserWithEmailAndPassword(
        auth,
        email.current.value,
        password.current.value
      )
        .then((userCredential) => {
          const user = userCredential.user;
          updateProfile(user, {
            displayName: name.current.value,
            photoURL: USER_AVTAR,
          })
            .then(() => {
              const { uid, email, displayName, photoURL } = auth.currentUser; // we want new auth info so we did this
              dispatch(
                addUser({
                  uid: uid,
                  email: email,
                  displayName: displayName,
                  photoURL: photoURL,
                })
              );
            })
            .catch((error) => {
              setErrorMessage(error.message);
            });
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          setErrorMessage(errorCode + "-" + errorMessage);
        });
    } else {
      //Sign In logic
      signInWithEmailAndPassword(
        auth,
        email.current.value,
        password.current.value
      )
        .then((userCredential) => {
          // const user = userCredential.user;
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          setErrorMessage(errorCode + "-" + errorMessage);
        });
    }
  };

  const toggleSigninForm = () => {
    setisSignInForm(!isSignInForm);
  };

  return (
    <div className="relative min-h-screen">
      <Header />
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src={BG_URL}
          alt="netflix-background"
        />
      </div>
      <div className="relative z-10 flex justify-center items-center min-h-screen py-20">
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="w-11/12 sm:w-8/12 md:w-6/12 lg:w-4/12 xl:w-3/12 p-6 sm:p-8 md:p-12 bg-black text-white rounded-lg bg-opacity-80"
        >
          <h1 className="font-bold text-2xl sm:text-3xl py-4">
            {isSignInForm ? "Sign In" : "Sign Up"}
          </h1>
          {!isSignInForm && (
            <input
              ref={name}
              type="text"
              placeholder="Full Name"
              className="p-2 sm:p-3 my-2 sm:my-4 w-full bg-gray-700 rounded"
              required
            />
          )}
          <input
            ref={email}
            type="text"
            placeholder="Email Address"
            className="p-2 sm:p-3 my-2 sm:my-4 w-full bg-gray-700 rounded"
            required
          />
          <input
            ref={password}
            type="password"
            placeholder="Password"
            className="p-2 sm:p-3 my-2 sm:my-4 w-full bg-gray-700 rounded"
            required
          />
          <p className="text-red-500 font-bold h-6 text-sm py-2 mb-4">
            {errorMessage}
          </p>
          <button
            className="p-3 sm:p-4 my-4 sm:my-6 bg-red-700 w-full rounded-lg"
            type="submit"
            onClick={handleButtonClick}
          >
            {isSignInForm ? "Sign In" : "Sign Up"}
          </button>
          <p
            className="py-2 sm:py-4 text-sm sm:text-base cursor-pointer"
            onClick={toggleSigninForm}
          >
            {isSignInForm
              ? "New to Netflix? Sign Up Now"
              : "Already registered? Sign in Now"}
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
